import React, { useContext, useState, useEffect } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import RuntimeValuesProvider, { RuntimeValuesContext } from '../context/RuntimeValuesContext';
import {useTranslation} from 'react-i18next';
import { Helmet } from 'react-helmet';

function Contact() {
    const [t, i18n] = useTranslation("global");
    const {runtimeValues, setRuntimeValues} = useContext(RuntimeValuesContext);
    const [title, setTitle] = useState<string>(t("pageTitle.contact") + t("seo.compl") + runtimeValues.country + " - wicaglobalgear.com");

    useEffect(() => {
        setTitle(t("pageTitle.contact") + t("seo.compl") + runtimeValues.country + " - wicaglobalgear.com");
        document.title = title;
    }, [runtimeValues.country]);     

return ( <>
        <Helmet>
            <title>{title}</title> 
        </Helmet>
        <div className="app-container">            
        <Header />
        <div className="app-content">
        <section className="sectionPageContent">
            <h1>
                {t("pageTitle.contact")} 
            </h1>   
            <p>{t("contact.content")}</p>  
            <p>Email: info@wicaglobalgear.com</p>  
            <p>{t("contact.phoneNumber")}: +1 (305) 890-4224</p>  
            <p>{t("contact.address")}: 46 NW 36th St #2, Miami, FL 33127, USA<br/>HGAB STUDIOS</p>  
            <span className="spanFilter">{t("contact.countriesTitle")}</span>
            <ul>
                <li>Chile</li>
                <li>Colombia</li>
                <li>Ecuador</li>
                <li>El Salvador</li>
                <li>Paraguay</li>
                <li>Peru</li>
                <li>USA</li>
            </ul>             
        </section> 
        </div>                 
        <Footer />
        </div>        
        </>    );
}

export default Contact;      